export const SCALES = [10, 11, 12, 13, 14, 15, 16];

export const adjustFontSize = (scale: number) => {
  document.documentElement.style.fontSize = scale + 'px';
};

export const removeExtraThemeLinks = () => {
  const themeLinks = document.querySelectorAll('link#theme-link');
  themeLinks.forEach((link, index) => {
    if (index === 0) {
      return;
    }
    link.parentNode?.removeChild(link);
  });
};
